export const moduleCompatibilityLink = 'https://www4.enphase.com/en-us/support/module-compatibility';
export const JWT_HMAC_SECRET = 'eNsToReEnPh@Se';
export const JWT_ALGORITHM = 'HS256';
